import { useSyncExternalStore } from 'react';

type Listener = () => void;

let isRedesignAnnouncementDialogOpen = false;
const listeners = new Set<Listener>();

const subscribe = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = (): boolean => isRedesignAnnouncementDialogOpen;

export const setRedesignAnnouncementDialogOpen = (open: boolean): void => {
  if (isRedesignAnnouncementDialogOpen === open) {
    return;
  }
  isRedesignAnnouncementDialogOpen = open;
  listeners.forEach((listener) => listener());
};

export const useIsRedesignAnnouncementDialogOpen = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
